import React from 'react';
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaTiktok,
  FaWhatsapp
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/Logo MulByte version 1 ameliorer.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Colonne À propos */}
          <div className="footer-col about-col">
            <Link to="/"><img src={logo} alt="MulByte Logo" className="footer-logo" /></Link>
            <p className="footer-about">
              Votre partenaire en solutions digitales innovantes pour propulser votre entreprise à l'ère numérique.
            </p>
          </div>

          {/* Colonne Liens rapides */}
          <div className="footer-col">
            <h3 className="footer-title">Liens rapides</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/#services">Services</Link></li>
              <li><Link to="/#portfolio">Portfolio</Link></li>
              <li><Link to="/#about">À propos</Link></li>
              <li><Link to="/#contact">Contact</Link></li>
              {/* <li><Link to="/politique-de-confidentialite">Politique de confidentialité</Link></li> */}
            </ul>
          </div>

          {/* Colonne Réseaux sociaux */}
          <div className="footer-col social-col">
            <h3 className="footer-title">Suivez-nous</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61579426947467" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/in/mulbyte-agency-20263a37a" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="#" aria-label="Youtube"><FaYoutube /></a>
              <a href="https://www.tiktok.com/@mulbyte5" target="_blank" rel="noopener noreferrer" aria-label="Tiktok"><FaTiktok /></a>
              <a href=" https://wa.me/message/Q63GCO6ZSZ67O1" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>
        </div>

        {/* Footer bottom */}
        <div className="footer-bottom">
          <div className="social-links-mobile">
            <a href="https://www.facebook.com/profile.php?id=61579426947467" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/in/mulbyte-agency-20263a37a" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" aria-label="Youtube"><FaYoutube /></a>
            <a href="https://www.tiktok.com/@mulbyte5" target="_blank" rel="noopener noreferrer" aria-label="Tiktok"><FaTiktok /></a>
            <a href=" https://wa.me/message/Q63GCO6ZSZ67O1" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
          </div>
          <div className="copyright">
            &copy; {new Date().getFullYear()} MulByte. Tous droits réservés.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
